import Media from './Media'
export default Media
